export default "__VITE_ASSET__75c9a371__"